<div class="mb-3" #hotTableContainer></div>
